module.exports = "/images/lv.svg?80ef022bfa6c8f5b078999524f101c95";